export function getSafeNextPath(value, fallback = "/") {
  if (typeof value !== "string") return fallback;
  const path = value.trim();
  if (!path.startsWith("/") || path.startsWith("//") || /[\\\u0000-\u001F\u007F]/.test(path)) {
    return fallback;
  }
  try {
    const origin = "https://navigation.kre8.invalid";
    const parsed = new URL(path, origin);
    if (parsed.origin !== origin) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function withNextPath(path, nextPath) {
  const safeNextPath = getSafeNextPath(nextPath);
  if (safeNextPath === "/") return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}next=${encodeURIComponent(safeNextPath)}`;
}
